import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';

class TimeSlotsMatrixButton extends React.Component {
  handleClick = () => {
    const { position, row, clickUpdate } = this.props;
    clickUpdate(row, position);
  };
  render() {
    const { checked, label, clickUpdate, disabled } = this.props;
    return (
      <td>
        <RaisedButton
          className="treat-sched-button"
          disabled={disabled}
          label={label}
          primary={checked}
          onClick={clickUpdate ? this.handleClick : null}
        />
      </td>
    );
  }
}

TimeSlotsMatrixButton.defaultProps = {
  clickUpdate: null,
  disabled: false,
};

TimeSlotsMatrixButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  position: PropTypes.number.isRequired,
  row: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  clickUpdate: PropTypes.func,
  disabled: PropTypes.bool,
};

export default TimeSlotsMatrixButton;
